import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=1a5c2d18"
import script from "./contactBlock.ts?vue&type=script&lang=js&external"
export * from "./contactBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports